import { getSharedData } from '@/ui/util';
import type { Page } from 'rune-ts';

function getChannelLocale(lang: string) {
  if (lang == 'en') return 'en';
  if (lang == 'jp') return 'ja';
  return 'ko';
}

export const initChannelTalk = (page: Page<object>) => {
  const { lang, user, client_id, device, is_app, theme } = getSharedData(page);

  const MarppleShop = '9ca9ebcf-b7cb-4f85-9a7f-b515d3812522';
  const Marpple = '76f20dbe-67a5-413b-910e-0146f0acdf13';

  window.ChannelIO(
    'boot',
    {
      pluginKey: theme === 'MarppleShop' ? MarppleShop : Marpple, // fill your plugin key
      language: getChannelLocale(lang),
      ...(user
        ? {
            memberId: user.uid,
            name: user.name,
            profile: {
              name: user.name,
              email: user.email,
              is_app,
              device,
              client_id,
            },
          }
        : {}),
    },
    () => {
      window.ChannelIO('updateUser', {
        language: getChannelLocale(lang), // sync user language
      });
    },
  );
};
